import { BlocHookOptions, useBloc } from "@blac/react";
import { createContext, FC, ReactNode, useContext } from "react";
import { SchedulerBloc } from "./SchedulerBloc";

const SchedulerInstanceContext = createContext<string | undefined>(undefined);

export const SchedulerInstanceProvider: FC<{
  id: string;
  children: ReactNode;
}> = ({ id, children }) => (
  <SchedulerInstanceContext.Provider value={id}>
    {children}
  </SchedulerInstanceContext.Provider>
);

export const useSchedulerBloc = (
  options?: Omit<BlocHookOptions<SchedulerBloc>, "id">
) => {
  const id = useContext(SchedulerInstanceContext);
  return useBloc(SchedulerBloc, { ...options, id });
};
